import DataGrid, { Column } from 'devextreme-react/data-grid';
import { PropertyStatusTypeOptions } from '@apply/constants';

const ApplicationPortfolioTable = ({ data }) => {
    const onAddressCellRender = (e) => {
        if (e.data.address.street2) {
            return e.data.address.street1 + ', ' + e.data.address.street2;
        } else {
            return e.data.address.street1;
        }
    };

    const onStatusIdRender = (e) => {
        const statusType = PropertyStatusTypeOptions.find((a) => a.id === e.data.propertyStatusId);
        return statusType?.shortName;
    };

    if (!data || data.length === 0) {
        return '';
    }

    return (
        <DataGrid
            dataSource={data}
            showBorders={true}
            showRowLines={false}
            rowAlternationEnabled={true}
            remoteOperations={false}
            allowColumnReordering={false}
            allowColumnResizing={true}
            width={'95%'}
            cellHintEnabled={true}
        >
            <Column
                dataField='propertyStatusId'
                caption='Status'
                width={120}
                cellRender={onStatusIdRender}
                alignment={'left'}
            />
            <Column
                dataField='address.street1'
                caption='Address'
                cellRender={onAddressCellRender}
            />
            <Column
                dataField='address.city'
                caption='City'
                width={150}
            />
            <Column
                dataField='address.state'
                caption='State'
                width={70}
            />
            <Column
                dataField='address.zipCode'
                caption='Zip'
                width={70}
            />
            <Column
                dataField='bfiNumber'
                caption='BFI #'
                dataType='string'
                width={100}
            />
        </DataGrid>
    );
};

export default ApplicationPortfolioTable;
